// extracted by mini-css-extract-plugin
export var scrollArea = "_q2-0";